import { render, staticRenderFns } from "./PackageSizeSelector.vue?vue&type=template&id=1b06b57e&scoped=true"
import script from "./PackageSizeSelector.vue?vue&type=script&lang=js"
export * from "./PackageSizeSelector.vue?vue&type=script&lang=js"
import style0 from "./PackageSizeSelector.vue?vue&type=style&index=0&id=1b06b57e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b06b57e",
  null
  
)

export default component.exports